module.exports = __webpack_public_path__ + "img/moon-icon.24df8a9e.png";